import { anyIncludes } from './arrays.js';
export const mediaType = (src) => {
    if (!src)
        return 'unkown';
    if (anyIncludes(src.toLowerCase(), ['.mp4', '.mov']))
        return 'video';
    if (anyIncludes(src.toLowerCase(), ['.jpg', '.jpeg', '.webp', '.png', '.webm']))
        return 'image';
    return 'unkown';
};
export const isImage = (src) => mediaType(src) === 'image';
export const isVideo = (src) => mediaType(src) === 'video';
export const fileTypes = {
    // Text files
    txt: 'text/plain',
    html: 'text/html',
    css: 'text/css',
    csv: 'text/csv',
    // Image files
    jpg: 'image/jpeg',
    JPG: 'image/jpeg',
    jpeg: 'image/jpeg',
    png: 'image/png',
    gif: 'image/gif',
    bmp: 'image/bmp',
    svg: 'image/svg+xml',
    tiff: 'image/tiff',
    ico: 'image/vnd.microsoft.icon',
    webp: 'image/webp',
    // Audio files
    mp3: 'audio/mpeg',
    wav: 'audio/wav',
    ogg: 'audio/ogg',
    m4a: 'audio/mp4',
    aac: 'audio/aac',
    // Video files
    mp4: 'video/mp4',
    webm: 'video/webm',
    ogv: 'video/ogg',
    avi: 'video/x-msvideo',
    mov: 'video/quicktime',
    mkv: 'video/x-matroska',
    // Application files
    pdf: 'application/pdf',
    zip: 'application/zip',
    gzip: 'application/gzip',
    rar: 'application/vnd.rar',
    tar: 'application/x-tar',
    '7z': 'application/x-7z-compressed',
    doc: 'application/msword',
    docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    xls: 'application/vnd.ms-excel',
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    ppt: 'application/vnd.ms-powerpoint',
    pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    js: 'application/javascript',
    json: 'application/json',
    xml: 'application/xml',
    rtf: 'application/rtf',
    // Font files
    ttf: 'font/ttf',
    otf: 'font/otf',
    woff: 'font/woff',
    woff2: 'font/woff2',
    // Miscellaneous files
    epub: 'application/epub+zip',
    azw: 'application/vnd.amazon.ebook',
    bin: 'application/octet-stream',
    exe: 'application/vnd.microsoft.portable-executable',
    dmg: 'application/x-apple-diskimage',
    iso: 'application/x-iso9660-image',
};
//# sourceMappingURL=file-manipulation.js.map